import { render } from "./TestCustomTable.vue?vue&type=template&id=00bacb20"
import script from "./TestCustomTable.vue?vue&type=script&lang=js"
export * from "./TestCustomTable.vue?vue&type=script&lang=js"

import "./TestCustomTable.vue?vue&type=style&index=0&id=00bacb20&lang=css"

import exportComponent from "/codebuild/output/src2326401477/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__